import { Directive, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[click-outside-event]',
})
export class ClickOutsideEventDirective {
  @Output() clickOutside = new EventEmitter<void>();
  constructor(private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event'])
  public onClick(event) {
    try {
      const clickedInside = this.elementRef.nativeElement.contains(event.target);
      
      if (!clickedInside) {
        this.clickOutside.emit();
      }
    } catch (e) {
      console.log("ClickOutsideDirective Error")
    }
  }
}